import { render, staticRenderFns } from "./VesselOverview.vue?vue&type=template&id=649a5246&scoped=true&"
import script from "./VesselOverview.vue?vue&type=script&lang=js&"
export * from "./VesselOverview.vue?vue&type=script&lang=js&"
import style0 from "./VesselOverview.vue?vue&type=style&index=0&id=649a5246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a5246",
  null
  
)

export default component.exports